<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      style="width: 400px;"
    >
      <div class="row q-ma-md">
        <q-input
          v-model="filter"
          label="Filter"
          outlined
          clearable
          class="col"
        />
        <q-checkbox
          v-if="iconImage && allowCustomImage"
          v-model="customIcon"
          class="col-4"
          label="Upload Your Own Icon"
        />
      </div>
      <q-icon-picker
        v-if="!customIcon"
        v-model:pagination="pagination"
        class="q-my-md"
        :model-value="model[iconProperty]"
        icon-set="material-icons"
        :filter="filter && filter.toLowerCase()"
        style="height: 220px;"
        tooltips
        @update:model-value="iconSelected"
      />
      <div
        v-else-if="allowCustomImage"
        class="row jusitfy-start items-center q-ma-md"
      >
        <div
          class="column col-auto"
          style="height: 120px; width: 120px;"
        >
          <span
            class="text-caption text-bold q-pb-sm"
            style="line-height: 11px;"
          >
            Custom Icon
          </span>
          <image-uploader
            v-model="model[iconImage]"
            class="col"
            style="height: 100px; width: 100px;"
            :min-height="'100px'"
            :image-url="model[iconImagePreviewUrl]"
            :model="model"
          />
        </div>
        <div class="col">
          <p>Recommended formats: PNG or SVG (supports transparency)</p>
          <ul>
            <li>Transparent background</li>
            <li>Contains color</li>
            <li>No extra spacing around the image</li>
          </ul>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import ImageUploader from 'src/modules/admin/components/ImageUploader.vue'
export default {
  name: 'IconPickerDialog',
  components: {
    ImageUploader
  },
  props: {
    iconProperty: {
      type: String,
      required: true
    },
    iconImage: {
      type: String,
      required: false,
      default: null
    },
    iconImagePreviewUrl: {
      type: String,
      required: false,
      default: null
    },
    model: {
      type: Object,
      required: true
    },
    allowCustomImage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      filter: this.model ? this.model[this.iconProperty] : '',
      shown: false,
      pagination: {
        itemsPerPage: 60,
        page: 0
      },
      customIcon: !!this.model[this.iconImage]
    }
  },
  watch: {
    customIcon (value) {
      if (value) {
        this.filter = ''
        this.model[this.iconProperty] = null
      } else {
        this.model[this.iconImage] = null
      }
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    iconSelected (value) {
      this.model[this.iconProperty] = value
      this.shown = false
    }
  }
}

</script>

<style lang="scss" scoped>
.drop-image {
  border: solid 2px black;
}
.dragover {
  border: dotted 4px red !important;
}

.q-icon-picker :deep(.q-icon-picker__footer label) {
  width: 5em !important;
}

</style>
